import {
  getInformasiBesaranSubsidi,
  postInformasiBesaranSubsidi,
  deleteInformasiBesaranSubsidi,
} from '../../utils/api';

export const FETCH_SUBSIDY_START = 'INFORMASI_BESARAN_SUBSIDI/FETCH_START';
export const FETCH_SUBSIDY_MORE_START = 'INFORMASI_BESARAN_SUBSIDI/FETCH_MORE_START';
export const FETCH_SUBSIDY_SUCCESS = 'INFORMASI_BESARAN_SUBSIDI/FETCH_SUCCESS';
export const FETCH_SUBSIDY_FAILED = 'INFORMASI_BESARAN_SUBSIDI/FETCH_FAILED';

export const SUBMIT_SUBSIDY_START = 'INFORMASI_BESARAN_SUBSIDI/SUBMIT_START';
export const SUBMIT_SUBSIDY_SUCCESS = 'INFORMASI_BESARAN_SUBSIDI/SUBMIT_SUCCESS';
export const SUBMIT_SUBSIDY_FAILED = 'INFORMASI_BESARAN_SUBSIDI/SUBMIT_FAILED';

export const DELETE_SUBSIDY_START = 'INFORMASI_BESARAN_SUBSIDI/DELETE_START';
export const DELETE_SUBSIDY_SUCCESS = 'INFORMASI_BESARAN_SUBSIDI/DELETE_SUCCESS';
export const DELETE_SUBSIDY_FAILED = 'INFORMASI_BESARAN_SUBSIDI/DELETE_FAILED';

export const CLEAR_SUBSIDY_MESSAGE = 'INFORMASI_BESARAN_SUBSIDI/CLEAR_MESSAGE';

export const fetchInformasiBesaranSubsidi = (params = {}, isLoadMore = false) =>
  async (dispatch) => {
    const queryParams = { page: 1, size: 100, ...params };
    dispatch({ type: isLoadMore ? FETCH_SUBSIDY_MORE_START : FETCH_SUBSIDY_START });
    try {
      const res = await getInformasiBesaranSubsidi(queryParams);
      if (res && (res.code === 200 || res.success || res.status === 'OK' || res.data)) {
        const payloadData = res.data || res;
        const extractedMeta =
          res.meta || res.data?.meta || res.pagination || res.data?.pagination || null;
        dispatch({
          type: FETCH_SUBSIDY_SUCCESS,
          payload: payloadData,
          meta: extractedMeta,
          isLoadMore,
        });
      } else {
        dispatch({
          type: FETCH_SUBSIDY_FAILED,
          payload: res?.message || 'Gagal mengambil data informasi besaran subsidi.',
        });
      }
    } catch (err) {
      dispatch({
        type: FETCH_SUBSIDY_FAILED,
        payload: err?.message || err?.status || 'Gagal mengambil data informasi besaran subsidi.',
      });
    }
  };

export const fetchCreateInformasiBesaranSubsidi = (payload) => async (dispatch) => {
  dispatch({ type: SUBMIT_SUBSIDY_START });
  try {
    const res = await postInformasiBesaranSubsidi(payload);
    if (res && (res.code === 200 || res.status === 'OK')) {
      dispatch({
        type: SUBMIT_SUBSIDY_SUCCESS,
        payload: 'Berhasil mengatur informasi besaran subsidi',
      });
      dispatch(fetchInformasiBesaranSubsidi());
    } else {
      dispatch({
        type: SUBMIT_SUBSIDY_FAILED,
        payload: res?.message || 'Gagal menambahkan informasi besaran subsidi.',
      });
    }
  } catch (err) {
    dispatch({
      type: SUBMIT_SUBSIDY_FAILED,
      payload: err?.message || err?.status || 'Gagal menambahkan informasi besaran subsidi.',
    });
  }
};

export const fetchDeleteInformasiBesaranSubsidi = (id) => async (dispatch) => {
  dispatch({ type: DELETE_SUBSIDY_START });
  try {
    const res = await deleteInformasiBesaranSubsidi(id);
    if (res && (res.code === 200 || res.status === 'OK')) {
      dispatch({
        type: DELETE_SUBSIDY_SUCCESS,
        payload: 'Berhasil menghapus informasi besaran subsidi',
      });
      dispatch(fetchInformasiBesaranSubsidi());
    } else {
      dispatch({
        type: DELETE_SUBSIDY_FAILED,
        payload: res?.message || 'Gagal menghapus riwayat besaran subsidi.',
      });
    }
  } catch (err) {
    dispatch({
      type: DELETE_SUBSIDY_FAILED,
      payload: err?.message || err?.status || 'Gagal menghapus riwayat besaran subsidi.',
    });
  }
};

export const clearSubsidyMessage = () => ({
  type: CLEAR_SUBSIDY_MESSAGE,
});
